import * as React from 'react';
import translate from '../../../../locale/translate';
import { getErrorObject } from '../../util/RemoteDataUtil';
import { IRemoteData } from '../../../../interfaces';

export function renderErrorObject(widgetName: string, widgetData: IRemoteData[]): JSX.Element {
    const errObj = getErrorObject(widgetName, widgetData);
    return (
        <div className="jumbotron">
            <h1>{translate.gettext("Error")}</h1>
            <pre>{errObj.message || 'unknown'}</pre>
            <pre className="se-4backend-err" style={{ "display": "none" } as React.CSSProperties}>{JSON.stringify(errObj)}</pre>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/widget/common/Render/renderErrorObject.tsx